var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReflect01 = function SvgReflect01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.962 20.5h-3.65q-.752 0-1.282-.531a1.74 1.74 0 0 1-.53-1.277V5.308q0-.747.531-1.277A1.74 1.74 0 0 1 5.308 3.5H8.96V5H5.308a.3.3 0 0 0-.221.086.3.3 0 0 0-.087.222v13.384a.3.3 0 0 0 .087.221.3.3 0 0 0 .22.087h3.654zM11.25 23V1.192h1.5V23zm3.789-2.5v-1.616h1.615V20.5zm0-15.385V3.5h1.615v1.615zM18.884 20.5v-1.616H20.5q0 .672-.474 1.144a1.56 1.56 0 0 1-1.142.472m0-3.846v-1.616H20.5v1.616zm0-3.846v-1.616H20.5v1.616zm0-3.847V7.346H20.5v1.615zm0-3.846V3.5q.667 0 1.142.474.474.475.474 1.141z"
  })));
};
export default SvgReflect01;